import { render } from "./sapSyncParam.vue?vue&type=template&id=60c68bb8&scoped=true"
import script from "./sapSyncParam.vue?vue&type=script&lang=js"
export * from "./sapSyncParam.vue?vue&type=script&lang=js"

import "./sapSyncParam.vue?vue&type=style&index=0&id=60c68bb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c68bb8"]])

export default __exports__